export default{
    
    lista:{
        method:'get',
        url:'usuario/lista'
    },
    cadastra:{
        method:'post',
        url:'usuario/cadastro'
    },
    delete:{
        method:'delete',
        url:'usuario/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'usuario/editar{/id}'
    },
    update:{
        method:'post',
        url:'usuario/update'
    },
    permissao:{
        method:'post',
        url:'usuario/ferramenta/configuracao'
    },
 
}